import { Directive, HostListener, Input, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { MediaAPI } from '@shared-features/services';
import { LoadingService } from '@shared/services/loading.service';
import { SectionState } from '@shared-features/enums/layout.enum';

@Directive({ selector: '[appMediaLink]' })
export class MediaLinkDirective implements OnDestroy {
  @Input('appMediaLink') mediaId: number;
  @Input() mediaDownload = false;

  private destroy$ = new Subject<void>();

  constructor(private mediaApiService: MediaAPI, private loadingService: LoadingService) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    if (!this.mediaId) return;
    event.preventDefault();
    this.loadingService.startLoading(SectionState.LoadingTransparent);
    this.mediaApiService
      .getMedia(this.mediaId)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => this.loadingService.stopLoading())
      )
      .subscribe((media) => {
        window.open(this.mediaDownload && media.downloadUrl ? media.downloadUrl : media.url, '_blank');
      });
  }
}